/* eslint-disable */
export const summary2025 = {
  totalDays: 365,
  workDays: 239,
  nonWorkDays: 126,
  workHours40: 1903,
  workHours36: 1714,
  workHours24: 1142,
}

export const quarters2025 = [
  {
    id: 1,
    name: { AZ: 'I Rüb', ENG: '1st Quarter', RU: 'I Квартал', TR: '1. Çeyrek' },
    period: { AZ: 'Yanvar — Mart', ENG: 'January — March', RU: 'Январь — Март', TR: 'Ocak — Mart' },
    workDays: 52,
    nonWorkDays: 38,
    workHours: 413,
    monthIndices: [0, 1, 2],
  },
  {
    id: 2,
    name: { AZ: 'II Rüb', ENG: '2nd Quarter', RU: 'II Квартал', TR: '2. Çeyrek' },
    period: { AZ: 'Aprel — İyun', ENG: 'April — June', RU: 'Апрель — Июнь', TR: 'Nisan — Haziran' },
    workDays: 58,
    nonWorkDays: 33,
    workHours: 460,
    monthIndices: [3, 4, 5],
  },
  {
    id: 3,
    name: { AZ: 'III Rüb', ENG: '3rd Quarter', RU: 'III Квартал', TR: '3. Çeyrek' },
    period: { AZ: 'İyul — Sentyabr', ENG: 'July — September', RU: 'Июль — Сентябрь', TR: 'Temmuz — Eylül' },
    workDays: 66,
    nonWorkDays: 26,
    workHours: 528,
    monthIndices: [6, 7, 8],
  },
  {
    id: 4,
    name: { AZ: 'IV Rüb', ENG: '4th Quarter', RU: 'IV Квартал', TR: '4. Çeyrek' },
    period: { AZ: 'Oktyabr — Dekabr', ENG: 'October — December', RU: 'Октябрь — Декабрь', TR: 'Ekim — Aralık' },
    workDays: 63,
    nonWorkDays: 29,
    workHours: 502,
    monthIndices: [9, 10, 11],
  },
]

export const months2025 = [
  {
    index: 0,
    quarter: 1,
    name: { AZ: 'Yanvar', ENG: 'January', RU: 'Январь', TR: 'Ocak' },
    days: 31,
    startOffset: 2, // Wednesday
    workDays: 18,
    nonWorkDays: 13,
    workHours: 143,
    specialDays: {
      1: { type: 'holiday', title: { AZ: 'Yeni il bayramı', ENG: "New Year's Day", RU: 'Новый год' } },
      2: { type: 'holiday', title: { AZ: 'Yeni il bayramı', ENG: "New Year's Day", RU: 'Новый год' } },
      3: { type: 'holiday', title: { AZ: 'İstirahət günü (NK qərarı ilə yerdəyişmə)', ENG: 'Non-working day (shifted)', RU: 'Перенесенный выходной день', TR: 'İstirahət günü (NK qərarı ilə yerdəyişmə)' } },
      20: { type: 'mourning', title: { AZ: 'Ümumxalq hüzn günü (20 Yanvar)', ENG: 'National Mourning Day', RU: 'День всенародной скорби', TR: '20 Ocak Ulusal Yas Günü' } },
      28: { type: 'shortened', title: { AZ: '1 saat qısaldılmış iş günü (7 saat)', ENG: '1 hour shortened work day (7h)', RU: 'Сокращенный рабочий день на 1 час (7ч)', TR: '1 saat kısaltılmış iş günü (7 saat)' } },
      29: { type: 'holiday', title: { AZ: 'Bələdiyyə seçkiləri günü (qeyri-iş günü)', ENG: 'Municipal election day (non-working)', RU: 'День муниципальных выборов (выходной)', TR: 'Bələdiyyə seçkiləri günü (qeyri-iş günü)' } },
    },
  },
  {
    index: 1,
    quarter: 1,
    name: { AZ: 'Fevral', ENG: 'February', RU: 'Февраль', TR: 'Şubat' },
    days: 28,
    startOffset: 5, // Saturday
    workDays: 20,
    nonWorkDays: 8,
    workHours: 160,
    specialDays: {},
  },
  {
    index: 2,
    quarter: 1,
    name: { AZ: 'Mart', ENG: 'March', RU: 'Март', TR: 'Mart' },
    days: 31,
    startOffset: 5, // Saturday
    workDays: 14,
    nonWorkDays: 17,
    workHours: 110,
    specialDays: {
      7: { type: 'shortened', title: { AZ: '1 saat qısaldılmış iş günü (7 saat)', ENG: '1 hour shortened work day (7h)', RU: 'Предпраздничный день (сокращен на 1 час)', TR: '1 saat kısaltılmış iş günü (7 saat)' } },
      8: { type: 'holiday', title: { AZ: 'Qadınlar günü', ENG: "Women's Day", RU: 'Женский день' } },
      10: { type: 'holiday', title: { AZ: 'Qadınlar gününün köçürülmüş istirahət günü', ENG: "Transferred Women's Day", RU: 'Перенесенный выходной день (Женский день)' } },
      19: { type: 'shortened', title: { AZ: 'Novruzqabağı 1 saat qısaldılmış iş günü (7 saat)', ENG: '1 hour shortened work day (7h)', RU: 'Предпраздничный день (сокращен на 1 час)', TR: 'Nevruz öncesi 1 saat kısaltılmış iş günü (7 saat)' } },
      20: { type: 'holiday', title: { AZ: 'Novruz bayramı', ENG: 'Novruz Holiday', RU: 'Праздник Новруз', TR: 'Nevruz Bayramı' } },
      21: { type: 'holiday', title: { AZ: 'Novruz bayramı', ENG: 'Novruz Holiday', RU: 'Праздник Новруз', TR: 'Nevruz Bayramı' } },
      22: { type: 'holiday', title: { AZ: 'Novruz bayramı', ENG: 'Novruz Holiday', RU: 'Праздник Новруз', TR: 'Nevruz Bayramı' } },
      23: { type: 'holiday', title: { AZ: 'Novruz bayramı', ENG: 'Novruz Holiday', RU: 'Праздник Новруз', TR: 'Nevruz Bayramı' } },
      24: { type: 'holiday', title: { AZ: 'Novruz bayramı', ENG: 'Novruz Holiday', RU: 'Праздник Новруз', TR: 'Nevruz Bayramı' } },
      25: { type: 'holiday', title: { AZ: 'Novruz bayramı ilə əlaqədar istirahət günü', ENG: 'Novruz Holiday non-working day', RU: 'Перенесенный выходной день (Новруз)', TR: 'Nevruz Bayramı tatili' } },
      26: { type: 'holiday', title: { AZ: 'Novruz bayramı ilə əlaqədar istirahət günü', ENG: 'Novruz Holiday non-working day', RU: 'Перенесенный выходной день (Новруз)', TR: 'Nevruz Bayramı tatili' } },
      30: { type: 'holiday', title: { AZ: 'Ramazan bayramı', ENG: 'Ramadan Holiday', RU: 'Праздник Рамазан', TR: 'Ramazan Bayramı' } },
      31: { type: 'holiday', title: { AZ: 'Ramazan bayramı', ENG: 'Ramadan Holiday', RU: 'Праздник Рамазан', TR: 'Ramazan Bayramı' } },
    },
  },
  {
    index: 3,
    quarter: 2,
    name: { AZ: 'Aprel', ENG: 'April', RU: 'Апрель', TR: 'Nisan' },
    days: 30,
    startOffset: 1, // Tuesday
    workDays: 21,
    nonWorkDays: 9,
    workHours: 168,
    specialDays: {
      1: { type: 'holiday', title: { AZ: 'Ramazan bayramı ilə əlaqədar istirahət günü', ENG: 'Ramadan Holiday non-working day', RU: 'Перенесенный выходной день (Рамазан)', TR: 'Ramazan Bayramı tatili' } },
    },
  },
  {
    index: 4,
    quarter: 2,
    name: { AZ: 'May', ENG: 'May', RU: 'Май', TR: 'Mayıs' },
    days: 31,
    startOffset: 3, // Thursday
    workDays: 20,
    nonWorkDays: 11,
    workHours: 158,
    specialDays: {
      8: { type: 'shortened', title: { AZ: '1 saat qısaldılmış iş günü (7 saat)', ENG: '1 hour shortened work day (7h)', RU: 'Предпраздничный день (сокращен на 1 час)', TR: '1 saat kısaltılmış iş günü (7 saat)' } },
      9: { type: 'holiday', title: { AZ: 'Faşizm üzərində qələbə günü', ENG: 'Victory Day', RU: 'День Победы', TR: '9 Mayıs Zafer Günü' } },
      27: { type: 'shortened', title: { AZ: '1 saat qısaldılmış iş günü (7 saat)', ENG: '1 hour shortened work day (7h)', RU: 'Предпраздничный день (сокращен на 1 час)', TR: '1 saat kısaltılmış iş günü (7 saat)' } },
      28: { type: 'holiday', title: { AZ: 'Müstəqillik Günü', ENG: 'Independence Day', RU: 'День независимости', TR: 'Müstəqillik Günü' } },
    },
  },
  {
    index: 5,
    quarter: 2,
    name: { AZ: 'İyun', ENG: 'June', RU: 'Июнь', TR: 'Haziran' },
    days: 30,
    startOffset: 6, // Sunday
    workDays: 17,
    nonWorkDays: 13,
    workHours: 134,
    specialDays: {
      5: { type: 'shortened', title: { AZ: '1 saat qısaldılmış iş günü (7 saat)', ENG: '1 hour shortened work day (7h)', RU: 'Предпраздничный день (сокращен на 1 час)', TR: '1 saat kısaltılmış iş günü (7 saat)' } },
      6: { type: 'holiday', title: { AZ: 'Qurban bayramı', ENG: 'Eid al-Adha', RU: 'Праздник Гурбан', TR: 'Kurban Bayramı' } },
      7: { type: 'holiday', title: { AZ: 'Qurban bayramı', ENG: 'Eid al-Adha', RU: 'Праздник Гурбан', TR: 'Kurban Bayramı' } },
      9: { type: 'holiday', title: { AZ: 'Qurban bayramı ilə əlaqədar istirahət günü', ENG: 'Transferred Eid non-working day', RU: 'Перенесенный выходной день (Гурбан)', TR: 'Qurban bayramı ilə əlaqədar istirahət günü' } },
      15: { type: 'holiday', title: { AZ: 'Milli Qurtuluş Günü', ENG: 'National Salvation Day', RU: 'День национального спасения', TR: 'Milli Qurtuluş Günü' } },
      16: { type: 'holiday', title: { AZ: 'Milli Qurtuluş Gününün köçürülmüş istirahət günü', ENG: 'Transferred Salvation Day', RU: 'Перенесенный выходной день', TR: 'Milli Qurtuluş Gününün köçürülmüş istirahət günü' } },
      25: { type: 'shortened', title: { AZ: '1 saat qısaldılmış iş günü (7 saat)', ENG: '1 hour shortened work day (7h)', RU: 'Предпраздничный день (сокращен на 1 час)', TR: '1 saat kısaltılmış iş günü (7 saat)' } },
      26: { type: 'holiday', title: { AZ: 'Silahlı Qüvvələr Günü', ENG: 'Armed Forces Day', RU: 'День Вооруженных сил', TR: 'Silahlı Qüvvələr Günü' } },
    },
  },
  {
    index: 6,
    quarter: 3,
    name: { AZ: 'İyul', ENG: 'July', RU: 'Июль', TR: 'Temmuz' },
    days: 31,
    startOffset: 1, // Tuesday
    workDays: 23,
    nonWorkDays: 8,
    workHours: 184,
    specialDays: {},
  },
  {
    index: 7,
    quarter: 3,
    name: { AZ: 'Avqust', ENG: 'August', RU: 'Август', TR: 'Ağustos' },
    days: 31,
    startOffset: 4, // Friday
    workDays: 21,
    nonWorkDays: 10,
    workHours: 168,
    specialDays: {},
  },
  {
    index: 8,
    quarter: 3,
    name: { AZ: 'Sentyabr', ENG: 'September', RU: 'Сентябрь', TR: 'Eylül' },
    days: 30,
    startOffset: 0, // Monday
    workDays: 22,
    nonWorkDays: 8,
    workHours: 176,
    specialDays: {},
  },
  {
    index: 9,
    quarter: 4,
    name: { AZ: 'Oktyabr', ENG: 'October', RU: 'Октябрь', TR: 'Ekim' },
    days: 31,
    startOffset: 2, // Wednesday
    workDays: 23,
    nonWorkDays: 8,
    workHours: 184,
    specialDays: {},
  },
  {
    index: 10,
    quarter: 4,
    name: { AZ: 'Noyabr', ENG: 'November', RU: 'Ноябрь', TR: 'Kasım' },
    days: 30,
    startOffset: 5, // Saturday
    workDays: 18,
    nonWorkDays: 12,
    workHours: 143,
    specialDays: {
      7: { type: 'shortened', title: { AZ: '1 saat qısaldılmış iş günü (7 saat)', ENG: '1 hour shortened work day (7h)', RU: 'Предпраздничный день (сокращен на 1 час)', TR: '1 saat kısaltılmış iş günü (7 saat)' } },
      8: { type: 'holiday', title: { AZ: 'Zəfər Günü', ENG: 'Victory Day', RU: 'День Победы', TR: 'Zəfər Günü' } },
      9: { type: 'holiday', title: { AZ: 'Dövlət Bayrağı Günü', ENG: 'State Flag Day', RU: 'День Государственного флага', TR: 'Dövlət Bayrağı Günü' } },
      10: { type: 'holiday', title: { AZ: 'Zəfər Gününün köçürülmüş istirahət günü', ENG: 'Transferred Victory Day', RU: 'Перенесенный выходной день', TR: 'Zəfər Gününün köçürülmüş istirahət günü' } },
      11: { type: 'holiday', title: { AZ: 'Dövlət Bayrağı Gününün köçürülmüş istirahət günü', ENG: 'Transferred Flag Day', RU: 'Перенесенный выходной день', TR: 'Dövlət Bayrağı Gününün köçürülmüş istirahət günü' } },
    },
  },
  {
    index: 11,
    quarter: 4,
    name: { AZ: 'Dekabr', ENG: 'December', RU: 'Декабрь', TR: 'Aralık' },
    days: 31,
    startOffset: 0, // Monday
    workDays: 22,
    nonWorkDays: 9,
    workHours: 175,
    specialDays: {
      30: { type: 'shortened', title: { AZ: '1 saat qısaldılmış iş günü (7 saat)', ENG: '1 hour shortened work day (7h)', RU: 'Предпраздничный день (сокращен на 1 час)', TR: '1 saat kısaltılmış iş günü (7 saat)' } },
      31: { type: 'holiday', title: { AZ: 'Dünya Azərbaycanlılarının Həmrəyliyi Günü', ENG: 'Solidarity Day of World Azerbaijanis', RU: 'День солидарности азербайджанцев мира', TR: 'Dünya Azərbaycanlılarının Həmrəyliyi Günü' } },
    },
  },
]
